import { makeStyles } from '@material-ui/core'
import React from 'react'
import PropTypes from 'prop-types'
import { CTAButton } from '../components'
import { Space, Layout} from 'antd'

const { Header, Content, Footer, Sider } = Layout;

const useStyles = makeStyles(theme => ({
    root: {
        // height: '100%',
        // width: '100%',
        // padding: theme.spacing(2)
    },
    topBar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: theme.spacing(2),
        paddingBottom: '0px',
    },
    title: {
        fontWeight: '600',
        fontSize: '24px',
        color: '#171725',
    },
    content: {
        padding: theme.spacing(3),
        minHeight: '100vh'
    },
    footer: {
        background: '#FFF',
        textAlign: 'center',
    }
}))

/**
 * Dashboard content layout page with title and CTA button
 */
const DashboardPage = ({children, title, onCtaClick, ctaIcon, buttonText, hasCta=true,disabled=false, loading=false}) => {
    const classes = useStyles()

    return (
        <div className={classes.root}>
            <div className={classes.topBar}>
                <div className={classes.title}>{title}</div>
                {
                    hasCta && (
                        <CTAButton onClick={onCtaClick} disabled={disabled} loading={loading}>
                            <Space>
                                {ctaIcon}
                                <span>{buttonText}</span>
                            </Space>
                        </CTAButton>
                    )
                }
            </div>

            <div className={classes.content}>
                {children}
            </div>

            { process.env.NODE_ENV !== 'production' && 
                <Footer className={classes.footer}> Build verion: {process.env.REACT_APP_GIT_SHA} </Footer>
            }
        </div>
    )
}

// Dashboard page prop types
DashboardPage.propTypes = {
    children: PropTypes.element,
    /** Dashboard title  */
    title: PropTypes.string,
    /** Main Call to action button click handler */
    onCtaClick: PropTypes.func,
    /** CTA antd icon element */
    ctaIcon: PropTypes.element,
    /** CTA button text */
    buttonText: PropTypes.string,
    /** Show CTA button */
    hasCta: PropTypes.bool,
    /** CTA button disable */
    disabled: PropTypes.bool,
    /** CTA button loading */
    loading: PropTypes.bool
}

export default DashboardPage
